module.exports = __webpack_public_path__ + "img/survey-2.7552c9be.png";